import { constants } from './constants';

export const SharedAppConstants = constants([
  'SHARED_AUTHENTICATE',
  'DETECT_LOCATION',

  'HUB_LANDING_FETCH_REPORTS',

  // Accolade Types
  'ACCOLADE_TYPE_FETCH',
  'ACCOLADE_TYPE_INSERT',
  'ACCOLADE_TYPE_DELETE',
  'ACCOLADE_TYPE_UPDATE',
  'ACCOLADE_TYPE_RATING_FETCH',
  'ACCOLADE_TYPE_RATING_INSERT',
  'ACCOLADE_TYPE_RATING_DELETE',
  'ACCOLADE_TYPE_RATING_UPDATE',

  // Business Accolades
  'BUSINESS_ACCOLADE_FETCH',
  'BUSINESS_ACCOLADE_FETCH_ALL',

  // Scheduled Inventory history
  'BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH',
  'BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH_UNASSIGNED_CSV',

  'BOOKING_MODAL_CLEAR',
  'BOOKING_MODAL_SET_EDITING',
  'CANCELLATION_POLICY_FETCH_ALL',

  // CSRF
  'AUTHENTICATION_CSRF_REFRESH',

  'DYNAMIC_BATCH',
  'PATRON_WAITLIST_STATS_FETCH',
  'PATRON_STATS_FETCH',
  'REPORTING_FETCH_ALL',
  'REPORTING_FETCH_ALL_ASYNC',
  'REPORTING_FETCH_WORKFLOW',
  'REPORTING_FETCH_WORKFLOW_RESULTS',
  'REPORTING_SELECT_BUSINESS_FILTER',
  'REPORTING_SELECT_EXPERIENCE_FILTER',
  'REPORTING_SELECT_METRIC_FILTER',
  'REPORTING_SELECT_TICKET_TYPE_FILTER',
  'REPORTING_SELECT_DATE_RANGE_FILTER',
  'REPORTING_CLEAR',
  'QUESTION_RESENT',
  'QUESTION_RESPONSE_UPDATE',
  // Guest Profile Search (Directory)
  'GUEST_PROFILE_BUSINESS_NOTE_UPDATE',
  'GUEST_PROFILE_CLEAR_SELECTED',
  'GUEST_PROFILE_DIETARY_NOTE_UPDATE',
  'GUEST_PROFILE_FETCH_PATRON_PURCHASE_HISTORY',
  'GUEST_PROFILE_GET',
  'GUEST_PROFILE_CLEAR',
  'GUEST_PROFILE_DELETE',
  'GUEST_PROFILES_DELETE',
  'GUEST_PROFILE_EXPORT',
  'GUEST_PROFILE_FIND_EXISTING',
  'GUEST_PROFILE_CLEAR_EXISTING',
  'GUEST_PROFILE_VIEW',
  'GUEST_PROFILE_CLEAR_VIEW',
  'GUEST_PROFILE_IMAGE_UPDATE',
  'GUEST_PROFILE_MERGE_GUESTS',
  'GUEST_PROFILE_MERGE_CHECK',
  'GUEST_PROFILE_NOTE_UPDATE',
  'GUEST_PROFILE_SEARCH',
  'GUEST_PROFILE_SUGGEST',
  'GUEST_PROFILE_SELECT_PROFILE',
  'GUEST_PROFILE_UNSELECT_PROFILE',
  'GUEST_PROFILE_SELECT_ALL',
  'GUEST_PROFILE_UPDATE',
  'GUEST_PROFILE_TOGGLE_ADD_GUEST_PROFILE_MODAL',
  'GUEST_PROFILE_TOGGLE_EDIT_GUEST_PROFILE_MODAL',
  'GUEST_PROFILE_TOGGLE_MERGE_GUEST_PROFILES_MODAL',
  // Loyalty Program
  'LOYALTY_PROGRAM_FETCH_BALANCE',
  'PATRON_TAG_UPDATE',
  // Booking
  'BOOKING_NOTE_GET',
  'TICKET_GROUP_GET',
  // Secondary header option selectors (dropdowns/pickers)
  'OPTION_SELECTORS_SET_BUSINESS_FILTER',
  'OPTION_SELECTORS_SET_DATA',
  'PATRON_SEARCH',
  'PATRON_SEARCH_CLEAR',
  'PURCHASE_GET',
  'PURCHASE_FETCH_TIMELINE_EVENTS',
  'PURCHASE_BOOKING_NOTE_UPDATE',
  // Tags
  'TAGS_FETCH_ALL',
  'TAG_ADD',
  'TAG_UPDATE',
  'TAG_UPDATE_ALL',
  'TAG_PRIORITY_UPDATE',
  'TAG_REMOVE',
  'TAG_REORDER',
  // Tickets
  'TICKETS_FETCH_ALL',
  // Feature enabled/disabled status update
  'FEATURES_FETCH_ALL',
  // Fetch features that are enabled globally
  'FEATURES_FETCH_GLOBAL',
  // Toast notification constants
  'SHOW_INFO_TOAST',
  'SHOW_ERROR_TOAST',
  'CLEAR_TOAST',
  'REMOVE_TOAST',

  // Patron
  'PATRON_CARDS_FETCH_ALL',
  'PATRON_CARDS_CLEAR',
  'PATRON_FETCH_PAY_BY_EMAILS',
  'PATRON_FETCH_PURCHASE_HISTORY',
  'PATRON_UPDATE_PURCHASE_HISTORY_PURCHASE',
  'PATRON_FETCH_WAITLIST',
  'PATRON_FETCH_CHECKS',
  'PATRON_FETCH_WALKINS',
  'WAITLIST_DELETE',

  // Payment cards
  'PAYMENT_CARD_CLIENT_TOKEN',
  'PAYMENT_CARD_DELETE',
  'PAYMENT_CARD_DEVICE_DATA',
  'PAYMENT_CARD_FETCH',
  'PAYMENT_CARD_INSERT',
  'PAYMENT_CARD_PAYMENT_INTENT',
  'PAYMENT_CARD_SETUP_INTENT',
  'PAYMENT_CARD_TOKENIZE',
  'PAYMENT_CARD_FORWARD',

  'VALIDATE_PHONE_REQUEST',
  'VISIT_UPDATE',
  'VISIT_GET',
  'VISIT_POS_CHECK_GET',

  'ANNOUNCEMENTS_SET_UPDATE_SEEN',
  'ANNOUNCEMENTS_SHOW_EVENTS_UPGRADE_NAG',

  // Cookie consent
  'COOKIE_CONSENT_LEVEL_UPDATE',
  'SCRIPT_LOAD_UPDATE',

  // Do Nothing action
  'NULL',
]);
